import { useEffect, useState } from 'react'
import { useReducedMotion } from 'motion/react'

// Reduced-motion preference that is safe to branch rendering on: it reads false on the server
// and on the first client render (so hydration always matches), then switches after mount.
export const useReduceMotion = (): boolean => {
    const prefersReduced = useReducedMotion()
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    return mounted ? Boolean(prefersReduced) : false
}
